import type { StylesConfig } from "react-select";

export interface Option {
    value: string;
    label: string;
}

export const selectStyles: StylesConfig<any, boolean> = {
    control: (base, state) => ({
        ...base,
        minHeight: '36px',
        border: 'none',
        borderRadius: '6px',
        boxShadow: state.isFocused
            ? '0 0 0 3px hsl(var(--ring) / 0.5), 0 1px 2px 0 #0000000d'
            : '0 1px 2px 0 #0000000d',
        backgroundColor: 'white',
        outline: 'none',
        transition: 'box-shadow 150ms',
    }),
    menu: (base) => ({
        ...base,
        border: '1px solid black',
        borderRadius: '6px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        marginTop: '4px',
        zIndex: 50,
        overflow: 'hidden',
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 50,
    }),
    menuList: (base) => ({
        ...base,
        padding: '4px',
    }),
    option: (base, state) => ({
        ...base,
        fontSize: '14px',
        borderRadius: '4px',
        backgroundColor: state.isSelected ? '#f3f4f6' : state.isFocused ? '#f3f4f6' : 'white',
        color: 'black',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#e5e7eb',
        },
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: '#9ca3af',
        padding: '8px',
        ':hover': {
            color: '#6b7280',
        },
    }),
    clearIndicator: (base) => ({
        ...base,
        color: '#9ca3af',
        padding: '8px',
        ':hover': {
            color: '#6b7280',
        },
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: '14px',
        color: 'var(--muted-foreground)'
    })
};
